var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("h2", [_vm._v("Dashboard")]),
      _vm.showInfoDialog
        ? _c(
            "v-dialog",
            {
              attrs: { width: "500" },
              model: {
                value: _vm.showInfoDialog,
                callback: function($$v) {
                  _vm.showInfoDialog = $$v
                },
                expression: "showInfoDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "mx-auto", attrs: { "max-width": "450" } },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [
                          _vm._v(
                            "Ver Detalle " +
                              _vm._s(_vm.vehiculoSelected.patente_vehiculo) +
                              "\n        "
                          )
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function($event) {
                                  _vm.showInfoDialog = false
                                }
                              }
                            },
                            [_vm._v("close")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list",
                    { attrs: { "three-line": "" } },
                    [
                      [
                        _c("v-subheader", [
                          _vm._v(_vm._s(_vm.vehiculoSelected.avl))
                        ]),
                        _c("v-divider"),
                        _c(
                          "v-list-item",
                          { staticStyle: { "margin-left": "50px" } },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", {
                                  staticStyle: {
                                    position: "absolute",
                                    "margin-top": "2%"
                                  },
                                  domProps: { textContent: _vm._s("Estado: ") }
                                }),
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.vehiculoSelected.activo
                                      ? "green--text"
                                      : "red--text",
                                    staticStyle: {
                                      "font-size": "xx-large",
                                      position: "absolute",
                                      "margin-left": "50px",
                                      "margin-top": "2px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                local_shipping\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("br"),
                        _c("br"),
                        _c(
                          "v-list-item",
                          { staticStyle: { "margin-left": "50px" } },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", {
                                  domProps: {
                                    textContent: _vm._s(
                                      "Fecha Última Actividad: "
                                    )
                                  }
                                }),
                                _c("v-list-item-subtitle", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      "<span class='text--primary'>" +
                                        (_vm.vehiculoSelected
                                          .fecha_actividad === null
                                          ? "Sin transmisión"
                                          : _vm.vehiculoSelected
                                              .fecha_actividad) +
                                        "</span>"
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("br"),
                        _c("br"),
                        _c(
                          "v-card-actions",
                          { staticClass: "px-4 pb-4", attrs: { center: "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { "text-xs-center": "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "button-dialog",
                                    attrs: {
                                      color: _vm.vehiculoSelected.color
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.goPatente(
                                          _vm.vehiculoSelected.patente_vehiculo
                                            ? "/Torre-Control/dispositivos/" +
                                                _vm.vehiculoSelected.avl +
                                                "/" +
                                                _vm.vehiculoSelected
                                                  .patente_vehiculo
                                            : ""
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { dark: "", left: "" } },
                                      [_vm._v("devices_other")]
                                    ),
                                    _c("span", [_vm._v("Ver Dispositivos")])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("v-divider")
                      ]
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [
          _c("v-tab", { on: { click: _vm.selectMap } }, [
            _vm._v("Mapa de Flotas")
          ]),
          _c("v-tab", { on: { click: _vm.selectDatatable } }, [
            _vm._v("Tabla de Flotas")
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c("br"),
      _vm.tabSelected == 0
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "align-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", md6: "", lg2: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Patente" },
                    on: { input: _vm.onInputFilter },
                    model: {
                      value: _vm.patente,
                      callback: function($$v) {
                        _vm.patente = $$v
                      },
                      expression: "patente"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", md6: "", lg2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "", small: "" },
                      on: { click: _vm.onChangeFilter }
                    },
                    [_c("v-icon", [_vm._v("search")])],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.clearFilters(false)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("clear")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card",
                {
                  staticClass: "no-bg",
                  staticStyle: { "margin-left": "auto !important" },
                  attrs: { color: "rgb(250 250 250)", dark: "" }
                },
                [
                  _c("v-card-title", [
                    _c("i", {
                      staticClass: "material-icons",
                      staticStyle: {
                        width: "20px",
                        height: "20px",
                        "margin-top": "10px",
                        "border-radius": "50%",
                        background: "rgb(38 255 38)"
                      }
                    }),
                    _vm._v(":\n        "),
                    _c(
                      "span",
                      {
                        staticClass: "text-h5",
                        staticStyle: {
                          color: "#808080",
                          "font-size": "18px",
                          "margin-top": "10px",
                          "margin-right": "10px"
                        }
                      },
                      [_vm._v("\n          Positivo\n        ")]
                    ),
                    _c("i", {
                      staticClass: "material-icons",
                      staticStyle: {
                        width: "20px",
                        height: "20px",
                        "margin-top": "10px",
                        "border-radius": "50%",
                        background: "#FFF226",
                        "margin-right": "10px"
                      }
                    }),
                    _vm._v(":\n        "),
                    _c(
                      "span",
                      {
                        staticClass: "text-h5",
                        staticStyle: {
                          color: "#808080",
                          "font-size": "18px",
                          "margin-top": "10px",
                          "margin-right": "10px"
                        }
                      },
                      [_vm._v("\n          Preventivo\n        ")]
                    ),
                    _c("i", {
                      staticClass: "material-icons",
                      staticStyle: {
                        width: "20px",
                        height: "20px",
                        "margin-top": "10px",
                        "border-radius": "50%",
                        background: "rgb(255 72 72)",
                        "margin-right": "10px"
                      }
                    }),
                    _vm._v(":\n        "),
                    _c(
                      "span",
                      {
                        staticClass: "text-h5",
                        staticStyle: {
                          color: "#808080",
                          "font-size": "18px",
                          "margin-top": "10px",
                          "margin-right": "10px"
                        }
                      },
                      [_vm._v("\n          Negativo\n        ")]
                    ),
                    _c("i", {
                      staticClass: "material-icons",
                      staticStyle: {
                        width: "20px",
                        height: "20px",
                        "margin-top": "10px",
                        "border-radius": "50%",
                        background: "silver",
                        "margin-right": "10px"
                      }
                    }),
                    _vm._v(":\n        "),
                    _c(
                      "span",
                      {
                        staticClass: "text-h5",
                        staticStyle: {
                          color: "#808080",
                          "font-size": "18px",
                          "margin-top": "10px",
                          "margin-right": "10px"
                        }
                      },
                      [_vm._v("\n          Desconectado\n        ")]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.tabSelected == 1
        ? _c("v-layout", [
            _c(
              "span",
              {
                staticClass: "text-h5",
                staticStyle: {
                  color: "#808080",
                  "font-size": "18px",
                  "margin-top": "10px",
                  "margin-right": "10px"
                }
              },
              [
                _vm._v(
                  "\n      * Seleccione la flota para ver el listado de vehículos "
                ),
                _c("br"),
                _vm._v("\n      * NT = No Transmisión\n    ")
              ]
            )
          ])
        : _vm._e(),
      _vm.tabSelected == 1 ? _c("searchSimple") : _vm._e(),
      _c(
        "v-card",
        [
          _vm.tabSelected == 0
            ? _c("FlotasCarousel", {
                attrs: {
                  elementos: _vm.dataTable,
                  elementos2: _vm.dataTable2,
                  clientData: _vm.clientData
                }
              })
            : _vm._e(),
          _vm.tabSelected == 1
            ? _c(
                "div",
                {
                  staticClass: "right",
                  staticStyle: { display: "flex", "margin-top": "-50px" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        id: "btnExportCsv",
                        flat: "",
                        small: "",
                        color: "primary"
                      },
                      on: { click: _vm.onBtnExport }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download ")
                      ]),
                      _vm._v("  \n        "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.tabSelected == 1
            ? _c("Datatables", {
                attrs: { headers: _vm.headers, dataTable: _vm.dataTable }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }